// extracted by mini-css-extract-plugin
export default {"workingHours":"WorkingHours_workingHours__8RfKw","header":"WorkingHours_header__QvYgH","headerWithButton":"WorkingHours_headerWithButton__Htrlx"};